import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../images/reportInfo.png'


const _hoisted_1 = { class: "report-page" }
const _hoisted_2 = {
  ref: "optPic",
  class: "charts",
  style: {"position":"relative"}
}
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = {
  key: 0,
  class: "right"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = { class: "no-chart-info" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "暂无数据", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  id: "chart",
  ref: "chart",
  class: "chart-map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EchartRightBar = _resolveComponent("EchartRightBar")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
            (_ctx.echartHeaderOption?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_el_popover, {
                    placement: "bottom",
                    width: "auto",
                    "popper-class": "right-option",
                    trigger: "hover"
                  }, {
                    reference: _withCtx(() => [
                      _hoisted_5
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_EchartRightBar, { list: _ctx.echartHeaderOption }, null, 8, ["list"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_8, 512), [
        [_vShow, _ctx.showNoData]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
        [_vShow, !_ctx.showNoData]
      ])
    ], 512)
  ]))
}